export const SUPRA_TESTNET_CHAIN_ID = 519698972792 as const
export const SUPRA_MAINNET_CHAIN_ID = 1 as const // Ethereum mainnet (the name is historical)

export const SUPRA_SUPPORTED_CHAIN_IDS = [SUPRA_TESTNET_CHAIN_ID, SUPRA_MAINNET_CHAIN_ID] as const

export type SupraChainId = (typeof SUPRA_SUPPORTED_CHAIN_IDS)[number]
